
import { environment } from 'src/environments/environment';
import { Jobs } from './jobs.model';
import { Candidates } from './candidates.model';

export class CandidatesJobsApply {
  private id: number;
  private date_apply: any;
  private eligibility_rate: number;
  private cover_letter_path: string;
  private availability: string;
  private status: string;
  private mobility: string;
  private current_salary: string;
  private desired_salary: string;
  private cv_path: string;

  private jobs: Jobs;
  private candidates: Candidates;
  private jobsCandidatesTrainings: any[];
  private jobsCandidatesLanguages: any[];
  private jobsCandidatesSkills: any[];
  private jobsCandidatesExperiences: any[];
  private jobsCandidatesCertificates: any[];

  constructor(CandidatesJobsApply: any) {
    this.id = CandidatesJobsApply.id;
    this.date_apply = CandidatesJobsApply.date_apply;
    this.eligibility_rate = CandidatesJobsApply.eligibility_rate;
    this.cover_letter_path = CandidatesJobsApply.cover_letter_path;
    this.cv_path = CandidatesJobsApply.cv_path;

    this.availability = CandidatesJobsApply.availability;
    this.status = CandidatesJobsApply.status;
    this.mobility = CandidatesJobsApply.mobility;
    this.current_salary = CandidatesJobsApply.current_salary;
    this.desired_salary = CandidatesJobsApply.desired_salary;

    this.jobs = CandidatesJobsApply.jobs;
    this.candidates = new Candidates(CandidatesJobsApply.candidates);
    this.jobsCandidatesTrainings = CandidatesJobsApply.jobsCandidatesTrainings;
    this.jobsCandidatesLanguages = CandidatesJobsApply.jobsCandidatesLanguages;
    this.jobsCandidatesSkills = CandidatesJobsApply.jobsCandidatesSkills;
    this.jobsCandidatesExperiences = CandidatesJobsApply.jobsCandidatesExperiences;
    this.jobsCandidatesCertificates = CandidatesJobsApply.jobsCandidatesCertificates;
  }

  getId(): number {
    return this.id;
  }

  getDateApply(): any {
    return this.date_apply;
  }

  getEligibilityRate(): Number {
    return this.eligibility_rate;
  }

  getCoverLetterPath(): string {
    return (this.cover_letter_path != null && this.cover_letter_path != '') ? environment.apiUrl + this.cover_letter_path : this.cover_letter_path;
  }

  getAvailability(): string {
    return this.availability;
  }

  getStatus(): string {
    return this.status
  }

  getMobility(): string {
    return this.mobility;
  }

  getCurrentSalary(): string {
    return this.current_salary;
  }

  getDesiredSalary(): string {
    return this.desired_salary;
  }

  getCVPath(): string {
    return (this.cv_path != null && this.cv_path != '') ? environment.apiUrl + this.cv_path : this.cv_path;
  }

  getJobs(): Jobs {
    return this.jobs;
  }

  getCandidates(): Candidates {
    return this.candidates;
  }

  getobsCandidatesTrainings(): any[] {
    return this.jobsCandidatesTrainings;
  }

  getJobsCandidatesLanguages(): any[] {
    return this.jobsCandidatesLanguages;
  }

  getJobsCandidatesSkills(): any[] {
    return this.jobsCandidatesSkills;
  }

  getJobsCandidatesExperiences(): any[] {
    return this.jobsCandidatesExperiences;
  }

  getJobsCandidatesCertificates(): any[] {
    return this.jobsCandidatesCertificates;
  }
}